<template>
    <div class="my-pagination xy-center">
        <el-pagination
            hide-on-single-page
            background
            style="padding: 60px 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="pageSizes"
            :page-size="pSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: "pagination",
    props: {
        pSize: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        },
        pageNo: {
            type: Number,
            default: 1
        },
        pageSizes: {
            type: Array,
            default () {
                return [10, 20, 30, 50, 100]
            }
        }
    },
    methods: {
        handleSizeChange(val) {
            this.$emit("update:pSize", val)
            this.$emit("change")
        },
        handleCurrentChange(val) {
            this.$emit("update:pageNo", val)
            this.$emit("change")
        }
    }
}
</script>

<style lang="less">
.my-pagination {

    .el-pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;

        .el-pagination__sizes {
            height: 32px;
        }

        .el-pagination__sizes .el-input__inner {
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #DDDDDD;
            height: 32px;
        }
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        background: white;
        height: 32px;
        border: 1px solid #DDDDDD;
        min-width: 32px;
        border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li.el-icon-more {
        background: unset;
        border: unset;
    }
    .el-pagination__jump {
        .el-input__inner {
            height: 32px;
            min-width: 32px;
        }
    }
    .el-pagination__editor.el-input .el-input__inner {
        height: 32px;
        min-width: 32px;
    }
    .el-pagination button, .el-pagination span:not([class*=suffix]) {
        height: unset;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #1677FF;
    }
}
</style>
